import React, { useEffect } from "react"
import types from "prop-types"
import { isEqual } from "lodash-es"
import { useDispatch, useSelector } from "react-redux"
import {
  PUBLIC_CONTEXT,
  conversations as conversationsSelector,
  initialize,
  resetConversationsData,
} from "reduxSlices/formSubmissionConversationsSlice"
import withReduxProvider from "shared/withReduxProvider"
import PublicConversation from "./PublicConversation"

const PublicFormSubmissionConversationsSection = ({ formSubmissionSlug }) => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(initialize({ context: PUBLIC_CONTEXT, formSubmissionSlug }))

    return () => dispatch(resetConversationsData())
  }, [dispatch, formSubmissionSlug])

  const conversations = useSelector(conversationsSelector, isEqual)

  return (
    <>
      {
        conversations.map((conversation) => (
          <PublicConversation conversation={conversation} />
        ))
      }
    </>
  )
}

PublicFormSubmissionConversationsSection.propTypes = {
  formSubmissionSlug: types.string.isRequired,
}

export default withReduxProvider(PublicFormSubmissionConversationsSection)
